import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserContext } from "../UserContext";
import { useNavigate } from 'react-router-dom';
import PackDetails from '../PackDetails';
import { FaFileDownload, FaPlus, FaTimes, FaBox} from "react-icons/fa";
import html2pdf from 'html2pdf.js';
import Header from '../Header';
import apiClient from '../../api/client';
import { ASSET_BASE_URL } from '../../config/env';
import "./index.css";
import { toast } from 'react-toastify';

const PackDetailsView = () => {
    const { user, token } = useContext(UserContext);
    const [operatorRole, setoperatorRole] = useState('');
    const [operatorId, setoperatorId] = useState('');
    const [operator, setOperator] = useState(null);
    const [packDetails, setPackDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDuration, setSelectedDuration] = useState('All');
    const contentRef = useRef();
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [newPlan, setNewPlan] = useState({
        planName: '',
        plan: 'vrplay+ottplay',
        planCode: '',
        watchoPlanCode: '',
        planType: 'ottplay',
        duration: '',
        planPrice: '',
        enable: 'yes',
        app_ids: [],
    });
    const [availableApps, setAvailableApps] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const navigate = useNavigate();

    const handleAddNewPlan = () => {
        setIsAddModalOpen(true);
        setIsEditing(false);
        setNewPlan({
            planName: '',
            plan: 'vrplay+ottplay',
            planCode: '',
            duration: '',
            planPrice: '',
            enable: 'yes',
            app_ids: []
        });
    };

    useEffect(() => {
        const role = user.role? user.role : "operator";
        const id = user.operatorId;
        
        setoperatorRole(role);
        setoperatorId(id);
    }, [user]);

    const fetchPackagesDynamically = async () => {       
        setLoading(true);
        try {
            const { data } = await apiClient.get('/get_operator_plans_with_apps.php');
            if (data.length > 0) setPackDetails(data);
        } catch (err) {
            toast.warn('Network error.');
        } finally {
            setLoading(false);
        }
    };

    const fetchApps = async () => {
        try {
            const { data } = await apiClient.get('/get_apps.php');
            if (Array.isArray(data)) setAvailableApps(data);
        } catch (e) {
            // console.error("Failed to fetch apps", e);
        }
    };

    const fetchOperator = async () => {
        try {
            const { data } = await apiClient.get(`/operator_api.php?id=${operatorId}`);
            setOperator(data.operator);
        } catch (e) {
            // console.error("Failed to fetch operator", e);
        }
    };

    useEffect(() => {
        if (token && operatorId) {
            fetchPackagesDynamically();
            fetchApps();
            fetchOperator();
        }
    }, [token, operatorId]);

    const handleDownloadPDF = () => {
    setPdfLoading(true);
    const element = contentRef.current;
    
    // Clone the element to modify without affecting the original
    const clonedElement = element.cloneNode(true);
    
    // Function to recursively find and replace price text
    const replacePricesWithBlanks = (node) => {
        // Check if this node contains price information
        if (node.nodeType === 3) { // Text node
            let text = node.nodeValue;
            
            // Replace various price patterns with blanks
            text = text.replace(/Rs\.[\s]*[\d,]+(\.[\d]{2})?/g, 'Rs. ____');
            text = text.replace(/Plan Price:[\s]*[\d,]+(\.[\d]{2})?/g, 'Plan Price: ____');
            text = text.replace(/₹[\s]*[\d,]+(\.[\d]{2})?/g, '₹ ____');
            
            if (text !== node.nodeValue) {
                node.nodeValue = text;
            }
        } else if (node.nodeType === 1) { // Element node
            // Check for specific classes or data attributes
            if (node.classList.contains('plan-price') || 
                node.getAttribute('data-plan-price') ||
                node.textContent.match(/Rs\.|Plan Price|₹/)) {
                
                // Replace content while preserving structure
                if (node.querySelector && !node.querySelector('.plan-price, [data-plan-price]')) {
                    node.innerHTML = node.innerHTML
                        .replace(/Rs\.[\s]*[\d,]+(\.[\d]{2})?/g, 'Rs. ____')
                        .replace(/Plan Price:[\s]*[\d,]+(\.[\d]{2})?/g, 'Plan Price: ____')
                        .replace(/₹[\s]*[\d,]+(\.[\d]{2})?/g, '₹ ____');
                }
            }
            
            // Process child nodes
            for (let i = 0; i < node.childNodes.length; i++) {
                replacePricesWithBlanks(node.childNodes[i]);
            }
        }
    };
    
    // Apply the replacement to the cloned element
    replacePricesWithBlanks(clonedElement);
    
    const images = clonedElement.querySelectorAll("img");
    const promises = Array.from(images).map(img => 
        img.complete ? Promise.resolve() : new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
        })
    );
    
    Promise.all(promises).then(() => {
        html2pdf().set({
            margin: 0.5,
            filename: 'vrplay-packages.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { 
                scale: 2, 
                useCORS: true,
                onclone: (clonedDoc) => {
                    // Apply the same replacement in the onclone callback
                    const replaceInClone = (node) => {
                        if (node.nodeType === 3) {
                            let text = node.nodeValue;
                            text = text.replace(/Rs\.[\s]*[\d,]+(\.[\d]{2})?/g, 'Rs. ____');
                            text = text.replace(/Plan Price:[\s]*[\d,]+(\.[\d]{2})?/g, 'Plan Price: ____');
                            text = text.replace(/₹[\s]*[\d,]+(\.[\d]{2})?/g, '₹ ____');
                            
                            if (text !== node.nodeValue) {
                                node.nodeValue = text;
                            }
                        } else if (node.nodeType === 1) {
                            for (let i = 0; i < node.childNodes.length; i++) {
                                replaceInClone(node.childNodes[i]);
                            }
                        }
                    };
                    
                    replaceInClone(clonedDoc.body);
                }
            },
            jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        }).from(clonedElement).save().then(() => {
            setPdfLoading(false);
        });
    }).catch(() => {
        setPdfLoading(false);
    });
};

    const handleSubmit = async () => {        
        setSaveLoading(true);
        try {            
            const response = await apiClient.put('/edit_package.php', newPlan);

            const result = response.data;

            if (result.status === 'success') {
                toast.success(result.message);
                toggleAddModal();
                fetchPackagesDynamically(); // refresh the package list
            } else {
                toast.error(result.message || "Something went wrong.");                
            }
        } catch (err) {
            // console.error(err);
            toast.error("Failed to save package.");
        } finally {
            setSaveLoading(false);
        }
    };

    const toggleAddModal = () => {
        setIsAddModalOpen(!isAddModalOpen);
    };

    const handleAddPlan = async () => {
        const { planName, plan, planCode, watchoPlanCode, planType, duration, planPrice, enable, app_ids } = newPlan;

        if (!newPlan.planName || !newPlan.planType || !newPlan.duration || !newPlan.planPrice || !newPlan.enable) {
            toast.warn('All fields are required');
            return;
        }

        if (newPlan.planType === 'ottplay' && !newPlan.planCode) {
            toast.warn('Plan code is required for OTTPlay type');
            return;
        }

        if (newPlan.planType === 'watcho' && !newPlan.watchoPlanCode) {
            toast.warn('Watcho plan code is required for Watcho type');
            return;
        }

        setSaveLoading(true);
        
        try {            
            // Step 1: Add Plan
            const planRes = await apiClient.post('/add_package.php', {
                planName,
                plan,
                planType,
                planCode: planType === 'ottplay' ? planCode : null,
                watchoPlanCode: planType === 'watcho' ? watchoPlanCode : null,
                duration: Number(duration),
                planPrice: Number(planPrice),
                enable
            });
            const planData = planRes.data;
            if (planData.status !== 'success') {
                toast.error(planData.message || 'Failed to add plan');
                return;
            }

            // Step 2: Link Apps to Plan (assume latest ID or response has it)
            const getLastPlanIdRes = await apiClient.get('/get_last_plan_id.php');

            const { id: newPlanId } = getLastPlanIdRes.data;

            if (Array.isArray(app_ids) && app_ids.length > 0) {
                await apiClient.post('/link_apps_toplan.php', { plan_id: newPlanId, app_ids });
            }

            toast.success("Plan added successfully");
            setNewPlan({ planName: '', plan: 'vrplay+ottplay', planCode: '', duration: '', planPrice: '', enable: 'yes', app_ids: [] });
            toggleAddModal();
            fetchPackagesDynamically();
        } catch (err) {
            // console.error("Error adding plan:", err);
            toast.warn("Server error while adding plan");
        } finally {
            setSaveLoading(false);
        }
    };

    const handleAssignPlan = () => {
        navigate('/assign-plans')
    }

    const toggleApp = (appId) => {
        setNewPlan(prev => {
            const alreadySelected = prev.app_ids.includes(appId);
            const app_ids = alreadySelected
                ? prev.app_ids.filter(id => id !== appId)
                : [...prev.app_ids, appId];

            return { ...prev, app_ids };
        });
    };

    const filteredPackages = (
        selectedDuration === 'All'
            ? packDetails
            : packDetails.filter(pack => Number(pack.duration) === Number(selectedDuration))
        ).sort((a, b) => {
        // ✅ Special plans first
        if (Number(b.isSpecial) !== Number(a.isSpecial)) {
            return Number(b.isSpecial) - Number(a.isSpecial);
        }

        // ✅ Then by planOrder
        return Number(a.planOrder) - Number(b.planOrder);
        });

    return (
        <>
            <Header />

            <div className="pack-details-view-pack">
                <div className="header-section-pack">
                    <h1>Packages</h1>
                    <div className="header-actions-pack">
                        <button 
                            onClick={handleDownloadPDF} 
                            className="download-button-pack"
                            disabled={pdfLoading}
                        >
                            <FaFileDownload className='download-icon' />
                            {pdfLoading ? 'Generating...' : 'Download PDF'}
                        </button>
                        {operatorRole === "superadmin" && (
                            <button onClick={handleAddNewPlan} className="add-button-pack">
                                <FaPlus /> Add Plan
                            </button>
                        )}
                        {operatorRole === "superadmin" && (
                            <button onClick={handleAssignPlan} className="action-btn assign-btn">
                                <FaBox /> Assign Plan
                            </button>
                        )}
                        {operatorRole === "admin" && (
                            <button onClick={handleAssignPlan} className="action-btn assign-btn">
                                <FaBox /> Assign Plan
                            </button>
                        )}
                    </div>
                </div>

                <div className="filter-section-pack">
                    {['All', 30, 90, 180, 365].map(duration => (
                        <button
                            key={duration}
                            className={`filter-button-pack ${selectedDuration === duration ? 'active' : ''}`}
                            onClick={() => setSelectedDuration(duration)}
                        >
                            {duration === 'All' ? 'All Packages' : 
                             duration === 30 ? 'Monthly' :
                             duration === 90 ? 'Quarterly' :
                             duration === 180 ? 'Half Yearly' : 'Annual'}
                        </button>
                    ))}
                </div>

                {isAddModalOpen && (
                    <div className="modal-overlay-pack">
                        <div className="modal-content-pack">
                        <div className="modal-header-pack">
                            <h2>{isEditing ? 'Edit Plan' : 'Add New Plan'}</h2>
                            <button className="close-button-pack" onClick={toggleAddModal}>
                            <FaTimes />
                            </button>
                        </div>
                        
                        <div className="form-grid-pack">
                            <div className="form-group-pack">
                            <label>Plan Name *</label>
                            <input 
                                type="text" 
                                placeholder="Enter plan name" 
                                value={newPlan.planName}
                                onChange={(e) => setNewPlan({ ...newPlan, planName: e.target.value })} 
                            />
                            </div>

                            <div className="form-group-pack">
                            <label>Plan Type *</label>
                            <select 
                                value={newPlan.planType} 
                                onChange={(e) => setNewPlan({ 
                                ...newPlan, 
                                planType: e.target.value,
                                // clear opposite field when changing plan type
                                planCode: e.target.value === 'watcho' ? '' : newPlan.planCode,
                                watchoPlanCode: e.target.value === 'ottplay' ? '' : newPlan.watchoPlanCode
                                })}
                            >
                                <option value="ottplay">OTTPlay</option>
                                <option value="watcho">Watcho</option>
                            </select>
                            </div>

                            {/* OTTPlay Code (enabled when planType = ottplay) */}
                            <div className="form-group-pack">
                            <label>OTTPlay Plan Code *</label>
                            <input 
                                type="text" 
                                placeholder="Unique plan code" 
                                value={newPlan.planCode}
                                onChange={(e) => setNewPlan({ ...newPlan, planCode: e.target.value })} 
                                disabled={isEditing ? newPlan.planType !== 'ottplay' : false}
                            />
                            </div>

                            {/* Watcho Code (enabled when planType = watcho) */}
                            <div className="form-group-pack">
                            <label>Watcho Plan Code *</label>
                            <input 
                                type="text" 
                                placeholder="Unique watcho plan code" 
                                value={newPlan.watchoPlanCode}
                                onChange={(e) => setNewPlan({ ...newPlan, watchoPlanCode: e.target.value })} 
                                disabled={isEditing ? newPlan.planType !== 'watcho' : newPlan.planType !== 'watcho'}
                            />
                            </div>

                            <div className="form-group-pack">
                            <label>Duration (Days) *</label>
                            <input 
                                type="number" 
                                placeholder="e.g., 30, 90, 180, 365" 
                                value={newPlan.duration}
                                onChange={(e) => setNewPlan({ ...newPlan, duration: e.target.value })} 
                            />
                            </div>
                            
                            <div className="form-group-pack">
                            <label>Price (₹) *</label>
                            <input 
                                type="number" 
                                placeholder="Plan price" 
                                value={newPlan.planPrice}
                                onChange={(e) => setNewPlan({ ...newPlan, planPrice: e.target.value })} 
                            />
                            </div>

                            <div className="form-group-pack">
                            <label>Status *</label>
                            <select 
                                value={newPlan.enable} 
                                onChange={(e) => setNewPlan({ ...newPlan, enable: e.target.value })}
                            >
                                <option value="yes">Active</option>
                                <option value="no">Inactive</option>
                            </select>
                            </div>
                        </div>


                            <div className="apps-section-pack">
                                <label>Select Apps:</label>
                                <div className="app-grid-pack">
                                    {availableApps.map(app => (
                                        <div
                                            key={app.id}
                                            className={`app-card-pack ${newPlan.app_ids.includes(app.id) ? 'selected' : ''}`}
                                            onClick={() => toggleApp(app.id)}
                                        >
                                            <img 
                                                src={`${ASSET_BASE_URL}/${app.name.toLowerCase()}.png`} 
                                                alt={app.name} 
                                                className='ott-image-pack' 
                                                onError={(e) => {
                                                    e.target.src = 'https://via.placeholder.com/50x50?text=App';
                                                }}
                                            />
                                            <span>{app.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            
                            <div className="modal-actions-pack">
                                <button 
                                    className="cancel-button-pack" 
                                    onClick={toggleAddModal}
                                    disabled={saveLoading}
                                >
                                    Cancel
                                </button>
                                <button 
                                    className="save-button-pack" 
                                    onClick={isEditing ? handleSubmit : handleAddPlan}
                                    disabled={saveLoading}
                                >
                                    {saveLoading ? 'Saving...' : 'Save Plan'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {loading ? (
                    <div className="packages-loading-container">
                        <div className="packages-skeleton-loader">
                            {[...Array(6)].map((_, index) => (
                                <div key={index} className="package-skeleton-card">
                                    <div className="skeleton-package-header">
                                        <div className="skeleton-package-name"></div>
                                        <div className="skeleton-edit-btn"></div>
                                    </div>
                                    <div className="skeleton-package-duration"></div>
                                    <div className="skeleton-package-price"></div>
                                    <div className="skeleton-ott-container">
                                        {[...Array(4)].map((_, ottIndex) => (
                                            <div key={ottIndex} className="skeleton-ott-item"></div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : filteredPackages.length === 0 ? (
                    <div className="no-packages-found">
                        <h2>No Packages Found</h2>
                        <p>Try selecting a different duration filter or add a new plan.</p>
                    </div>
                ) : (
                    <div ref={contentRef} className="package-view-container-pack">
                        <div className='pack-grid-pack'>
                            {filteredPackages.map(pack => {
                                const modifiedPack = {
                                    ...pack,
                                    planPrice: operator ? pack.planPrice + operator.packPrice : pack.planPrice,
                                    showBlankPrice: false
                                };

                                return (
                                    <div 
                                        className={`pack-item-pack ${pack.isSpecial ? 'special-package' : ''}`} 
                                        key={pack.id}
                                        style={{ position: "relative" }}
                                        >

                                        {Number(pack.isSpecial) === 1 && (
                                            <div className="ribbon">
                                            <span>{pack.specialText || "POPULAR"}</span>
                                            </div>
                                        )}

                                        <PackDetails
                                            {...modifiedPack}
                                            originalPrice={
                                                pack.originalPrice 
                                                ? pack.originalPrice + (operator?.packPrice || 0)
                                                : null
                                            }
                                            isSpecial={pack.isSpecial}
                                            onEdit={() => {
                                                const matchedAppIds = availableApps
                                                    .filter(app => pack.ott?.includes(app.name))
                                                    .map(app => app.id);

                                                setNewPlan({
                                                    id: pack.id,
                                                    planName: pack.planName,
                                                    plan: pack.plan,
                                                    planType: pack.planType,
                                                    planCode: pack.planCode,
                                                    watchoPlanCode: pack.watchoPlanCode,
                                                    duration: pack.duration,
                                                    planPrice: pack.planPrice, // Original price without operator markup
                                                    enable: pack.enable,
                                                    app_ids: matchedAppIds,
                                                });

                                                setIsAddModalOpen(true);
                                                setIsEditing(true);
                                            }}
                                            canEdit={operatorRole === "superadmin"}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default PackDetailsView;